module.exports = __webpack_public_path__ + "img/project_icon_one.adce48f1.png";